<script>
	import Loading from "@/components/layout/Loading.vue";
	import InputRutForm from "@/components/formulario/InputRutForm.vue";
	import InputEmailForm from "@/components/formulario/InputEmailForm.vue";
	import InputFileForm from "@/components/formulario/InputFileForm.vue";
	import InputTextForm from "@/components/formulario/InputTextForm.vue";
	import InputDateForm from "@/components/formulario/InputDateForm.vue";
	import InputTicketForm from "@/components/formulario/InputTicketForm.vue";
	import SelectForm from "@/components/formulario/SelectForm.vue";
	import { mapActions } from "vuex";
	export default {
		props: {
			data: {
				type: Array,
				required: true
			},
			tipo: {
				required: true
			},
			dataGlobal: {
				type: Object,
				requierd: true
			},
			loading: {
				type: Boolean,
				required: true
			}
		},
		components: {
			Loading,
			InputRutForm,
			InputEmailForm,
			InputFileForm,
			SelectForm,
			InputTextForm,
			InputDateForm,
			InputTicketForm
		},
		data() {
			return {
				//Error
				errorForm: false,
				sending: false,
				loadingSolicitud: false,
			}
		},
		computed: {
			validation() {
				let formStatus = this.data.map(function (element) { 
					if(element.error && element.value === '' || element.value === false) return false;
					else return true;
				});
				return formStatus;
			},
			isValid() {
				let validation = this.validation
				return validation.every(element => element === true);
			},
		},
		methods: {
			...mapActions("BeneficioModule", ["crearSolicitudBeneficio"]),
			async submit() {
				if(this.isValid) {
					try {
						this.loadingSolicitud = true;
						this.data.forEach(element=>{
							if(element.field=="Selector"){
								this.dataGlobal.valor_formulario.push(
									{
										id_formulario_dato: element.id,
										valor_formulario: element.value.label
									}
								);
							}
							else if(element.field!="Selector" && element.field!="Archivo"){
								this.dataGlobal.valor_formulario.push(
									{
										id_formulario_dato: element.id,
										valor_formulario: element.value.toString()
									}
								);
							} //"codigoBase64;application/pdf" o "codigoBase64;image/jpg" 
							if (element.field == "Archivo")
							{
								try{
									let formato = element.value.split(":")[1].split(";")[0];
									let archivoBase64 = element.value.split(":")[1].split(";")[1].split(",")[1];
									let valuePreparado = archivoBase64.concat(";", formato);
									// console.log("Id elemento: ", element.id)
									//console.log("documento: ", archivoBase64.concat(";", formato));
									this.dataGlobal.valor_formulario.push(
										{
											id_formulario_dato: element.id,
											valor_formulario: valuePreparado
										}
									);
								}catch(error){
									console.log("submit para crear solicitud por usuario asociado a tipo de input Archivo, error: ", error);
								}
							}
						});	
						let detale_solicitud = [];
						detale_solicitud.push(this.dataGlobal);
						let data_ = {
							id_empresa: this.$ls.get("user").id_empresa_fk,
							id_tipo_solicitud: this.tipo,
							id_usuario: this.$ls.get("user").id_usuario,
							detalle_solicitud: detale_solicitud
						}
						await this.crearSolicitudBeneficio(data_).then(resultado=>{
							if(resultado)
							{
								this.sending = true;
								this.errorForm = false;
								detale_solicitud = [];
							}
							else{
								this.sending = false;
								this.errorForm = true;
							}
						}).catch(err=>{
							this.errorForm = true
							console.log("submit para crear solicitud: ", err);
							this.loadingSolicitud = false;
						});
						// if(this.sending){
						// 	this.dataGlobal = {
						// 		id_inventario: null,
						// 		inventario_detalle: null,
						// 		detalle_cantidad: "1",
						// 		valor_formulario: []
						// 	}
						// }
						// console.log("data_para_envio_form front: ", this.data);
						// console.log("data_para_envio_form filtrados: ", data_);
						this.loadingSolicitud = false;
					}
					catch (error) {
						console.log("submit para crear solicitud por usuario global solicitud: ", error);
						this.loadingSolicitud = false;
						this.sending = false;
						this.errorForm = true;
					}
				}
				else {
					this.sending = false;
					this.errorForm = true;
				}
			},
			agregarOtraSolicitud() {
				this.sending = false;
				this.$emit("agregarOtraSolicitud");
			}
		},
		watch: {
			data() {
				this.errorForm = false;
			}
		}
	}
</script>
<template>
	<section class="form-beneficios">
		<Loading
			v-if="loading || loadingSolicitud"
			pixeles="100px"
			class="mb-3"
		/>
		<form
			v-if="!loading && !sending && !loadingSolicitud" 
			@submit.prevent="submit"
		>
			<div 
				v-if="data.length === 0"
				class="row"
			>
				<div class="col-12">
					<div class="alert alert-light bg-light border text-center mb-0">
						<font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon>
						Formulario inactivo
					</div>
				</div>
			</div>
			<div 
				v-if="data.length !== 0"
				class="row">
				<div 
					v-for="item in data" :key="item.id"
					class="col-12 mb-3">

					<template v-if="item.field === 'Input'">
						<InputTextForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'InputRut' ">
						<InputRutForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'InputDate' ">
						<InputDateForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'InputEmail' ">
						<InputEmailForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'Archivo' ">
						<InputFileForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'Selector' ">
						<SelectForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'Ticket' ">
						<InputTicketForm 
							:data="item"
							:errorForm="errorForm"
						/>
					</template>

					<template v-if="item.field === 'InputNoEditable' || item.field === 'Default' ">
						<div class="card bg-light">
							<div class="card-body d-flex align-items-center justify-content-between text-secondary">
								<span>{{ item.label }}</span> 
								<span class="font-700">{{ item.inputNoEditable }}</span>
							</div>
						</div>
					</template>
				</div>
			</div>
			<div 
				v-if="data.length !== 0"
				class="row">
				<div class="col-12 d-flex justify-content-end mt-3">
				<button 
					type="submit"
					class="btn btn-custom btn-custom-main">
					<font-awesome-icon icon="fa-solid fa-plus" class="pe-2"></font-awesome-icon>
					Crear solicitud
				</button>
				</div>
			</div>
		</form>
		<div 
			v-if="sending && !loadingSolicitud"
			class="row"
		>
			<div class="col-12">
				<div class="alert alert-light border border-green color-green text-center mb-0">
					<font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon>
					Solicitud creada con éxtio.
				</div>
			</div>
			<div class="col-12 d-flex justify-content-end mt-3">
			<button 
				type="button"
				@click="agregarOtraSolicitud()"
				class="btn btn-custom btn-custom-main">
				<font-awesome-icon icon="fa-solid fa-plus" class="pe-2"></font-awesome-icon>
				Agregar otra solicitud
			</button>
			</div>
		</div>
	</section>
</template>
<style lang="scss">
	
</style>